import React from "react";
import { Sparkles, ArrowUpRight } from "lucide-react";
import useReveal from "../hooks/useReveal";
import { useContent } from "../context/ContentContext";

export default function Promotions() {
  const [ref, inView] = useReveal();
  const { content } = useContent();
  const promos = (content.promotions || []).filter((p) => p.active !== false);
  const bookUrl = content.settings.bookUrl;

  if (!promos.length) return null;

  return (
    <section id="promotions" className="bg-[#0C0C0C] py-24 md:py-28 px-6 border-t border-[#161616]">
      <div ref={ref} className={`max-w-6xl mx-auto reveal ${inView ? "in-view" : ""}`}>
        <div className="flex items-center gap-4 mb-3">
          <span className="gold-divider" />
          <span className="text-xs tracking-[0.25em] text-[#C6A15B] uppercase">Limited Time</span>
        </div>
        <h2 className="font-serif-display text-4xl md:text-6xl text-[#F7F2EA] mb-14">
          Current Promotions
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {promos.map((p) => (
            <div
              key={p.id || p.title}
              className="relative border border-[#C6A15B]/30 bg-gradient-to-b from-[#161616] to-[#111111] p-8 overflow-hidden"
            >
              <Sparkles className="absolute -right-3 -top-3 text-[#C6A15B]/10" size={90} />
              {p.badge ? (
                <span className="inline-block text-[10px] tracking-[0.2em] uppercase bg-[#C6A15B] text-[#0C0C0C] px-3 py-1 mb-5">
                  {p.badge}
                </span>
              ) : null}
              <h3 className="font-serif-display text-2xl text-[#F7F2EA] mb-3 relative">{p.title}</h3>
              {p.description ? (
                <p className="text-sm text-[#9E988B] leading-relaxed font-light relative">
                  {p.description}
                </p>
              ) : null}
              <a
                href={bookUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-flex items-center gap-2 text-xs tracking-[0.18em] uppercase text-[#C6A15B] hover:gap-3 transition-all relative"
              >
                Book to Redeem <ArrowUpRight size={16} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
